import { render, staticRenderFns } from "./InsuranceManage.vue?vue&type=template&id=3f4c2ea0&scoped=true"
import script from "./InsuranceManage.vue?vue&type=script&lang=js"
export * from "./InsuranceManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4c2ea0",
  null
  
)

export default component.exports